import React from "react";
import PropTypes from "prop-types";
import { TvDiv } from "@trustvid/design-system";
import { LOGIN_PAGE_HERO } from "./loginPageContent";

const LoginFeatureStats = ({ compact = false }) => (
  <TvDiv
    className={`tv-login-page__stats d-flex flex-wrap${compact ? " tv-login-page__stats--compact gap-2 gap-md-3" : " gap-3 gap-lg-4"}`}
  >
    {LOGIN_PAGE_HERO.stats.map((s) => (
      <TvDiv key={s.label} className={compact ? "tv-login-page__stat--compact" : undefined}>
        <TvDiv className="tv-login-page__stat-value">{s.value}</TvDiv>
        <TvDiv className="tv-login-page__stat-label">{s.label}</TvDiv>
      </TvDiv>
    ))}
  </TvDiv>
);

LoginFeatureStats.propTypes = {
  compact: PropTypes.bool,
};

export default LoginFeatureStats;
